__turbopack_context__.v({
  "button": "checkout-error-message-module-scss-module__mJy1tG__button",
  "message": "checkout-error-message-module-scss-module__mJy1tG__message",
  "section": "checkout-error-message-module-scss-module__mJy1tG__section",
  "title": "checkout-error-message-module-scss-module__mJy1tG__title",
});
